import { atom } from 'jotai';
import update from 'immutability-helper';
import { SensitivityConfig, SensitivityPayload } from './interface';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';

const selectedProductAtom = atom(CURRENT_PRODUCT_MODE || 'EI');

const drawerMetricsAtom = atom([]);

const aiCohortDrawerAtom = atom<{ open: boolean; metrics: string[]; key: string; isFlow: boolean }>(
  { open: false, metrics: [], key: '', isFlow: false },
);

const fullSensitivityConfigAtom = atom<SensitivityConfig[]>([]);

// Customer-wide selected video KPI (Conviva Good = 1 by default). Persisted to the synopsis
// vsi config via the sensitivity Save; initialized from the GET-sensitivity `kpiId`.
const selectedKpiIdAtom = atom<number>(1);

const updateSensitivityDataObjAtom = atom(null, (get, set, payload: SensitivityPayload) => {
  const data: any = get(fullSensitivityConfigAtom);
  const updatedData = update(data, { $merge: { [payload.key]: payload.value } });
  set(fullSensitivityConfigAtom, updatedData);
});

export {
  updateSensitivityDataObjAtom,
  selectedProductAtom,
  fullSensitivityConfigAtom,
  selectedKpiIdAtom,
  drawerMetricsAtom,
  aiCohortDrawerAtom,
};
